import clsx from "clsx";
import Image from "next/image";

import pinkOrb from "@musicfy/assets/images/pink_orb.webp";
import purpleOrb from "@musicfy/assets/images/purple_orb.webp";
import { PADDLE_TARGET_FRAME } from "@musicfy/libs/PaddleProvider";

import FullScreenWrapper from "./FullScreenWrapper";

const PaddleWrapper = ({
  open,
  onClose,
  isLoading,
  children,
  rightSlot,
}: {
  open: boolean;
  onClose?: () => void;
  isLoading?: boolean;
  children?: React.ReactNode;
  /** Stripe Embedded Checkout (Paddle leaves this empty and mounts its iframe). */
  rightSlot?: React.ReactNode;
}): JSX.Element => {
  return (
    <FullScreenWrapper open={open} onClose={onClose} isLoading={isLoading}>
      <div className="min-h-full flex flex-grow w-full relative xl:before:content-[''] xl:before:absolute xl:before:z-0 xl:before:w-1/2 xl:before:min-h-full">
        <div
          className={clsx(
            "w-full z-1 xl:grid xl:grid-cols-2 xl:items-stretch",
            {
              "min-h-full": !rightSlot,
              "xl:min-h-full": !!rightSlot,
            }
          )}
        >
          <div
            className={clsx(
              "overflow-x-hidden bg-cover bg-no-repeat xl:bg-[url('/paddle_bg.webp')] flex items-start xl:items-center justify-center",
              rightSlot ? "xl:min-h-full" : "min-h-full"
            )}
          >
            <div className="w-full h-fit px-4 py-3 xl:px-5 xl:py-4">
              <div className="xl:max-w-[500px] z-10 w-full h-fit mx-auto flex justify-center px-4 py-4 xl:px-5 bg-[#180e1d]/80 rounded-[18px] border border-white/[20%] border-opacity-20 backdrop-blur-3xl relative">
                <div className="absolute top-[-210px] left-[70px] max-xl:hidden">
                  <Image
                    src={pinkOrb}
                    width={226}
                    height={226}
                    alt="pink orb"
                  />
                </div>
                <div className="z-[1] absolute top-[200px] right-[-135px] max-xl:hidden">
                  <Image
                    src={purpleOrb}
                    width={162}
                    height={162}
                    alt="purple orb"
                  />
                </div>
                {children}
              </div>
            </div>
          </div>
          <div
            className={clsx(
              !rightSlot && PADDLE_TARGET_FRAME,
              "z-10 w-full mx-auto flex justify-center bg-gray-1000/80 backdrop-blur-md items-start xl:items-center",
              rightSlot ? "xl:min-h-full" : "min-h-full",
              {
                "animate-fade-in": !isLoading,
              }
            )}
          >
            {rightSlot ? (
              <div className="w-full h-fit px-4 pt-3 pb-8 xl:px-5 xl:py-4">
                <div className="xl:max-w-[500px] w-full h-fit mx-auto px-4 py-4 xl:px-0 xl:py-0 rounded-[18px] border border-white/20 xl:border-0 bg-[#180e1d]/80 xl:bg-transparent backdrop-blur-3xl xl:backdrop-blur-none">
                  {rightSlot}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </FullScreenWrapper>
  );
};

export default PaddleWrapper;
